{
  "dss": {
    "button": {
      "back": "Înapoi",
      "cancel": "Anulare",
      "close": "Închide",
      "confirmDelete": "Da, șterge",
      "continue": "Continuă",
      "logout": "Deconectare",
      "passwordReset": "Resetare parolă",
      "save": "Salvează",
      "verify": "Verifică"
    },
    "error": {
      "403": "Nu aveti acces la această pagină.",
      "404": "Această pagină nu există.",
      "generic": "A apărut o eroare. Vă rugăm sa reincercați mai tarziu.",
      "invalidConfirmationLink": "Link-ul de confirmare a expirat sau este din alt motiv invalid.",
      "throttling": "Prea multe încercări. Această operațiune este blocată pentru o perioadă de timp.",
      "title": "Eroare",
      "title403": "Acces interzis",
      "title404": "Nu a fost găsit"
    },
    "footer": {
      "imprint": "Informaţii legale",
      "legalEntity": "SC ANDREAS STIHL MOTOUNELTE SRL",
      "privacy": "Protecția Datelor",
      "terms": "Termeni și Condiții"
    },
    "label": {
      "CRMAccountNumber": "Număr cont",
      "contact": "Contact",
      "email": "Email",
      "faq": "FAQ",
      "female": "Dna./Dra.",
      "firstname": "Prenume",
      "help": "Ajutor",
      "language": "Limbă",
      "lastname": "Nume familie",
      "male": "Dl.",
      "needHelp": "Aveți nevoie de ajutor?",
      "newPassword": "Parolă nouă",
      "newPassword2": "Confirmare parolă nouă",
      "oldPassword": "Parolă curentă",
      "organization": "Organizaţie",
      "password": "Parolă",
      "required": "obligatoriu",
      "salutation": "Salutare",
      "select": "Vă rugăm selectați"
    },
    "link": {
      "contact": "https://support.stihl.com/en-INT/websso-contact/",
      "faq": "https://support.stihl.com/en-INT/externalkbsearchwebsso/"
    },
    "page": {
      "confirm": {
        "title": "Confirmă Înregistrarea",
        "wait": "Va rugam să așteptați finalizarea înregistrării."
      },
      "otp": {
        "btnResend": "Retrimiterea codului de verificare",
        "msg": {
          "invalidOTP": "Parola dumneavoastră unică nu este valabilă.",
          "resendFail": "Erorare la retrimiterea codului de verificare. Vă rugam să reincercaţi mai târziu."
        },
        "spamDetail": "Verificaţi-vă poşta şi dosarul Spam dacă aţi primit un e-mail de la STIHL Support (noreply{'@'}stihl-sso.com)",
        "spamTitle": "Nu a-ți primit un e-mail?",
        "subtitle": "Pentru resetarea parolei dumneavoastră trebuie să vă verificăm adresa de e-mail.",
        "title": "Verificați-vă contul",
        "txtVerifyMail": "Vă rugăm să introduce-ți codul de verificare pe care vi l-am trimis la {email}"
      },
      "personal": {
        "msg": {
          "noChange": "Nu a fost efectuată nici o schimbare.",
          "updateError": "Eroare la actualizarea datelor personale.",
          "updated": "Datele personale au fost actualizate.",
          "userLoadErr": "Eroare la incărcarea datelor. Vă rugam să reîncerca-ţi mai târziu."
        },
        "secOrganization": "Organizaţie",
        "secPersonal": "Personal",
        "secSettings": "Preferinţe",
        "title": "Informaţii Personale"
      },
      "postPwSet": {
        "info": "Noua dumneavoastră parolă poate fi deja utilizată",
        "link_name": "Continuă la Self-Service",
        "link_url": "/user/ui/",
        "title": "Parola a fost salvată"
      },
      "resetPW": {
        "title": "Reinițializare parolă"
      },
      "security": {
        "2fa": {
          "availableMethods": "Metode disponibile pentru autentificare cu doi factori:",
          "info": "Autentificarea cu doi factori (2FA) este o funcție de securitate care adaugă un nivel suplimentar de protecție contului dvs. Aceasta solicită utilizarea a două metode pentru conectare, în loc de un singur nume de utilizator și parolă.",
          "method": {
            "email": "E-mail",
            "emailDesc": "Primiți coduri unice prin e-mail pentru a finaliza solicitările de autentificare.",
            "oath": {
              "add": {
                "button": "Înregistrează Aplicația de Autentificare"
              }
            }
          }
        },
        "authenticator": "Aplicație de autentificare",
        "infoFederatedAccount": "Acest cont este gestionat de furnizorul de identitate al organizației dvs., astfel încât parola nu poate fi schimbată aici. Pentru a vă schimba parola, conectați-vă prin pagina de conectare a organizației dvs. sau contactați administratorul IT.",
        "lastUse": "Utilizat ultima dată la {0}.",
        "msg": {
          "invalidPassword": "Parola curentă este incorectă.",
          "passwordAlreadyUsed": "Este interzisă refolosirea ultimelor 5 parole.",
          "pwUpdateError": "Eroare la schimbarea parolei.",
          "pwUpdated": "Parola a fost actualizată."
        },
        "noDevice": "Neconfigurat",
        "oathAdd": {
          "appInfo": "Aplicațiile de autentificare precum {0}, {1} etc. generează parole unice care sunt utilizate ca un al doilea factor în timpul conectării.",
          "badCode": "Cod invalid, vă rugăm să încercați din nou.",
          "error": "A apărut o eroare la încercarea de a înregistra dispozitivul de autentificare.",
          "headScan": "1. Scanați codul QR cu aplicația dvs. de autentificare",
          "headVerify": "2. Verificați codul",
          "infoKey": "cheie de configurare",
          "infoKeyTitle": "Secretul dvs. cu doi factori",
          "infoScanBottom": "Nu se poate scana? Puteți folosi {0} pentru a configura manual aplicația de autentificare.",
          "infoVerify": "Introduceți codul generat de aplicația dvs. de autentificare.",
          "success": "Dispozitivul dvs. de autentificare a fost înregistrat. Acum îl puteți utiliza pentru a vă conecta.",
          "title": "Înregistrați-vă dispozitivul de autentificare cu doi factori"
        },
        "oathDelete": {
          "error": "A apărut o eroare la încercarea de a șterge dispozitivul de autentificare.",
          "success": "Dispozitivul de autentificare a fost șters."
        },
        "passkeys": {
          "about": {
            "info1": "Cheile de acces sunt perechi de chei criptografice (una publică și una privată) care sunt stocate pe un dispozitiv de autentificare controlat de dvs. Dispozitivul de autentificare poate dovedi că utilizatorul este prezent și autorizat să folosească cheia de acces. Dispozitivele de autentificare verifică autorizarea utilizând un PIN, o parolă, date biometrice sau parola dispozitivului, în funcție de funcționalitățile și configurația dispozitivului respectiv. Aceste dispozitive pot include smartphone-uri (iPhone sau Android), Windows Hello, chei hardware FIDO2 sau un manager de parole.",
            "info2": "Când vă conectați la STIHL folosind o cheie de acces, dispozitivul dvs. de autentificare utilizează criptografia cu cheie publică pentru a dovedi identitatea dvs. către STIHL fără a trimite niciodată cheia privată. Cheile de acces sunt asociate cu un domeniu specific, cum ar fi stihl-sso.com, și necesită o conexiune securizată, ceea ce înseamnă că navigatorul va respinge încercările de autentificare pe un site de phishing. Aceste caracteristici fac ca cheile de acces să fie extrem de rezistente la atacurile de tip phishing și mult mai sigure decât metodele precum SMS sau 2FA TOTP, care pot fi vulnerabile la phishing.",
            "info3": "Serviciile de gestionare a cheilor de acces bazate pe cloud permit ca acestea să fie sincronizate între dispozitive (cum ar fi dispozitive Apple, Android sau manageri de parole), făcându-le accesibile din multiple locații și mai puțin susceptibile a fi pierdute. Odată ce ați configurat o cheie de acces sincronizată pe un dispozitiv, aceasta va fi disponibilă și pe alte dispozitive care utilizează același serviciu. De exemplu, dacă înregistrați o cheie de acces utilizând contul dvs. iCloud cu Touch ID pe MacBook, veți putea folosi acea cheie și pe alte dispozitive conectate la același cont iCloud folosind recunoașterea facială, PIN-ul sau parola dispozitivului.",
            "title": "Despre Cheile de Acces"
          },
          "add": {
            "button": "Adaugă o nouă Cheie de Acces",
            "error": "A apărut o eroare la încercarea de a adăuga o nouă cheie de acces.",
            "success": "O nouă cheie de acces a fost adăugată."
          },
          "delete": {
            "button": "Șterge Cheia de Acces",
            "error": "A apărut o eroare la încercarea de a șterge această cheie de acces.",
            "success": "Cheia de acces a fost ștearsă."
          },
          "edit": {
            "error": "A apărut o eroare la încercarea de a salva numele cheii de acces.",
            "name": "Numele Cheii de Acces",
            "success": "Numele cheii de acces a fost actualizat.",
            "title": "Atribuiți un nume cheii dvs. de acces pentru a o diferenția de altele"
          },
          "info": "O cheie de acces este o alternativă simplă și sigură la parole, care validează identitatea dvs. folosind atingerea, recunoașterea facială, parola dispozitivului sau un cod PIN.",
          "none": "Nicio cheie de acces configurată.",
          "reallyDelete": "Sunteți sigur că doriți să ștergeți această cheie de acces?",
          "registeredPasskeys": "Cheile de acces înregistrate:",
          "title": "Chei de Acces"
        },
        "reallyDeleteDevice": "Sunteți sigur că doriți să ștergeți dispozitivul de autentificare?",
        "secMFA": "Autentificare cu mai mulți factori",
        "secPwdChange": "Schimbare parolă",
        "title": "Logare si securitate"
      },
      "setPW": {
        "acceptTC": "Vă rugam sa acceptați {terms} și să citiți {privacy}.",
        "killSSO": "Invalidează toate sesiunile active",
        "msg": {
          "tokenExpired": "Link-ul sau codul de schimbare al parolei a expirat. Vă rugam să urmați link-ul următor pentru reinițializarea parolei: {link}."
        },
        "privacy": "Protecția Datelor",
        "terms": "Termenii și Condițiile STIHL",
        "title": "Înregistrare parolă nouă"
      }
    },
    "validations": {
      "hasDigit": "Trebuie sa conțină numere.",
      "hasLowercase": "Trebuie sa conțină litere mici.",
      "hasSpecial": "Trebuie sa conțină caractere speciale: {chars}",
      "hasUppercase": "Trebuie sa conțină litere mari.",
      "invalidCharacters": "Conține caractere nepermise!",
      "maxLength": "Maxim {max} caractere permise.",
      "minLength": "Minim {min} caractere",
      "notSameAsEmail": "Prea asemanatoare cu adresa de e-mail.",
      "onlyValidCharactersAllowed": "Sunt permise doar litere, cifre și spații.",
      "required": "Câmp obligatoriu",
      "sameAsPassword": "Parolele nu se potrivesc",
      "tcAccepted": "Vă rugăm sa acceptați termenii si condițiile STIHL.",
      "validEmail": "Adresa de e-mail invalidă.",
      "validOTP": "Vă rugăm să introduceți codul de verificare."
    }
  }
}
